import React, { useEffect, useState, useMemo } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


function LabReports() {
  const localToday = (() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  })();

  // helpers
  function mapPayMode(raw) {
    if (!raw) return '';
    const s = String(raw).trim().toLowerCase();
    if (s.includes('cash')) return 'Cash';
    if (s.includes('card') || s.includes('credit') || s.includes('debit') || s.includes('swipe')) return 'Card';
    if (s.includes('online') || s.includes('upi') || s.includes('gateway') || s.includes('net')) return 'Online';
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  }
  function classifyMode(raw) {
    if (!raw) return '';
    const s = String(raw).toLowerCase();
    if (s.includes('cash')) return 'cash';
    if (s.includes('card') || s.includes('credit') || s.includes('debit') || s.includes('swipe')) return 'card';
    if (s.includes('online') || s.includes('upi') || s.includes('gateway') || s.includes('net')) return 'online';
    return '';
  }

  function parseServerDate(datetimeStr) {
    if (!datetimeStr) return null;
    const cleaned = String(datetimeStr).replace('T', ' ').trim();
    // Expect "YYYY-MM-DD HH:MM:SS" or "YYYY-MM-DD"
    const [datePart, timePart] = cleaned.split(' ');
    const [year, month, day] = (datePart || '').split('-').map(n => parseInt(n, 10));
    if (!year || !month || !day) return null;
    let hours = 0, minutes = 0, seconds = 0;
    if (timePart) {
      const parts = timePart.split(':').map(n => parseInt(n, 10));
      hours = Number.isFinite(parts[0]) ? parts[0] : 0;
      minutes = Number.isFinite(parts[1]) ? parts[1] : 0;
      seconds = Number.isFinite(parts[2]) ? parts[2] : 0;
    }
    // create Date in local timezone
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  function toLocalYMD(dateObj) {
    if (!dateObj) return '';
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function formatDateTime12h(dateObj) {
    if (!dateObj) return '';
    const day = String(dateObj.getDate()).padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; hours = hours === 0 ? 12 : hours;
    const hourStr = String(hours).padStart(2, '0');
    return `${day} ${month}- ${year} ${hourStr}:${minutes} ${ampm}`;
  }

  // state
  const [summary, setSummary] = useState({
    totalReports: 0, totalAmount: 0, todaysCollection: 0, collectionBy: { cash: 0, online: 0, card: 0 }
  });

  const [totals, setTotals] = useState({
    totalCharges: "0.00",   // sum of lab_total
    finalAmount: "0.00",    // sum of lab_final_amt
    newPaid: "0.00",        // payments already on registration rows
    laterPaid: "0.00",      // payments from paymentsList (due-payments)
    totalPaid: "0.00",      // newPaid + laterPaid
    discountAmount: "0.00",
    totalDue: "0.00",
    totalRows: 0,
    cashTotal: "0.00",
    cardTotal: "0.00",
    onlineTotal: "0.00"
  });
  

  const [masterList, setMasterList] = useState([]);
  const [paymentsList, setPaymentsList] = useState([]);
  const [allTests, setAllTests] = useState([]);
  const [usersList, setUsersList] = useState([]);

  const [formData, setFormData] = useState({
    docs: [],
    l1: [],
    departs: [],
    search_key: '',
    from: localToday,
    to: localToday,
    lab_reg_referral_user_id: "",
    lab_reg_referral: "",
    selectedDepartment: "",
    selectedTest: "",
    selectedUserId: ""
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  // grouping preserving lab_paid breakdown by mode
  const groupByUHID = (records) => {
    const grouped = {};
    records.forEach(item => {
      const uhid = item.lab_reg_uhid || ('UHID_' + (item.lab_reg_id || Math.random()));
      const paidAmount = Number(item.lab_paid || 0);

      if (!grouped[uhid]) {
        grouped[uhid] = {
          lab_reg_id: item.lab_reg_id,
          lab_reg_uhid: item.lab_reg_uhid,
          lab_reg_name_title: item.lab_reg_name_title,
          lab_reg_name: item.lab_reg_name,
          lab_reg_mobile: item.lab_reg_mobile,
          lab_reg_referral: item.lab_reg_referral,
          lab_reg_user: item.lab_reg_user,
          last_used: item.last_used || item.fname || '',
          last_used_id: item.last_used_id || item.user_id || item.lab_reg_user || '',
          fname: item.fname || '',
          lab_reg_datetime: item.lab_reg_datetime || item.lab_reg_date || '',
          total_final_amt: Number(item.lab_final_amt || item.lab_total || 0),
          total_paid: paidAmount,
          total_due: Number(item.lab_due || 0),
          tests: item.tests && item.tests.length > 0 ? item.tests.map(t => ({ lab_item_test_name: t.lab_item_test_name || t.test_name || '' })) : [],
          department_ids: (item.params || []).map(p => p.test_cat).filter(Boolean),
          cash_amount: 0,
          card_amount: 0,
          online_amount: 0,
          __firstRow: item
        };
        const primaryMode = classifyMode(item.lab_pay_mode || item.lab_due_pay_mode || '');
        if (primaryMode === 'cash') grouped[uhid].cash_amount += paidAmount;
        else if (primaryMode === 'card') grouped[uhid].card_amount += paidAmount;
        else if (primaryMode === 'online') grouped[uhid].online_amount += paidAmount;
      } else {
        // merge
        const newTests = (item.tests || []).map(t => ({ lab_item_test_name: t.lab_item_test_name || t.test_name || '' }));
        grouped[uhid].tests.push(...newTests);
        (item.params || []).forEach(p => {
          if (p && p.test_cat && !grouped[uhid].department_ids.includes(p.test_cat)) grouped[uhid].department_ids.push(p.test_cat);
        });
        grouped[uhid].total_final_amt = grouped[uhid].total_final_amt || Number(item.lab_final_amt || item.lab_total || 0);
        grouped[uhid].total_paid = grouped[uhid].total_paid || paidAmount;
        grouped[uhid].total_due = grouped[uhid].total_due || Number(item.lab_due || 0);

        const prevDt = parseServerDate(grouped[uhid].lab_reg_datetime || '');
        const thisDt = parseServerDate(item.lab_reg_datetime || item.lab_reg_date || '');
        if (thisDt && (!prevDt || thisDt.getTime() > prevDt.getTime())) grouped[uhid].lab_reg_datetime = item.lab_reg_datetime || item.lab_reg_date || grouped[uhid].lab_reg_datetime;

        const primaryMode = classifyMode(item.lab_pay_mode || item.lab_due_pay_mode || '');
        if (primaryMode === 'cash') grouped[uhid].cash_amount += paidAmount;
        else if (primaryMode === 'card') grouped[uhid].card_amount += paidAmount;
        else if (primaryMode === 'online') grouped[uhid].online_amount += paidAmount;

        if (!grouped[uhid].last_used && (item.last_used || item.fname)) {
          grouped[uhid].last_used = item.last_used || item.fname || grouped[uhid].last_used;
          grouped[uhid].last_used_id = item.last_used_id || item.user_id || item.lab_reg_user || grouped[uhid].last_used_id;
        }
      }
    });
    return Object.values(grouped);
  };

  // main fetch + logic
  const initData = async () => {
    const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    if (!storedDataF.user_id) {
      console.warn("No user in sessionStorage (ldata). Aborting fetch.");
      return;
    }

    try {
      const fd = new FormData();
      fd.append('search_key', formData.search_key || "");
      fd.append('from', formData.from ? `${formData.from} 00:00:00` : "");
      fd.append('to', formData.to ? `${formData.to} 23:59:59` : "");
      if (formData.lab_reg_referral_user_id && String(formData.lab_reg_referral_user_id).trim() !== '') {
        fd.append('lab_reg_user', String(formData.lab_reg_referral_user_id));
      }
      if (formData.selectedUserId && String(formData.selectedUserId).trim() !== '') {
        fd.append('lab_reg_user', String(formData.selectedUserId));
      }
      fd.append('page_no', 'none');

      // optional items call
      try {
        const resItm = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd);
        if (resItm.data && resItm.data.status && Array.isArray(resItm.data.records)) {
          setFormData(prev => ({ ...prev, l1: resItm.data.records }));
        } else {
          setFormData(prev => ({ ...prev, l1: [] }));
        }
      } catch (e) {
        console.warn("getLabRegListItmUrl failed:", e);
        setFormData(prev => ({ ...prev, l1: [] }));
      }

      const res = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListUrl, fd);
      if (res.data && res.data.status && Array.isArray(res.data.records)) {
        const records = res.data.records;
        setMasterList(records);

        // users
        const uMap = {};
        records.forEach(r => {
          const uid = r.last_used_id ?? r.lab_reg_user ?? r.user_id ?? null;
          const uname = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || (`User #${uid}`);
          if (uid) uMap[uid] = uname;
        });
        setUsersList(Object.keys(uMap).map(uid => ({ user_id: uid, name: uMap[uid] })));

        // fallback docs if none in formData.docs
        if (!formData.docs || formData.docs.length === 0) {
          const docMap = {};
          records.forEach(r => {
            if (r.type === 'doctor' || r.role_id === 'doctor') {
              const id = r.user_id || r.last_used_id || ('doc_' + (r.fname || r.lab_reg_referral || 'unknown'));
              docMap[id] = { user_id: id, fname: r.fname || r.last_used || r.lab_reg_referral || '' };
            } else if (r.lab_reg_referral && r.lab_reg_referral.trim() !== '') {
              const id = 'ref_' + r.lab_reg_referral;
              docMap[id] = { user_id: id, fname: r.lab_reg_referral };
            }
          });
          setFormData(prev => ({ ...prev, docs: Object.values(docMap) }));
        }

        // summary/today's collection (lab_paid + lab_due_pay_amount if due date == today)
        let totalReports = records.length;
        let totalAmount = 0;
        let todaysCollection = 0;
        let cashToday = 0, cardToday = 0, onlineToday = 0;
        const localTodayYMD = localToday;

        records.forEach(item => {
          totalAmount += Number(item.lab_final_amt ?? item.lab_total ?? 0);

          const regDt = parseServerDate(item.lab_reg_datetime || item.lab_reg_date || '');
          const localYmd = regDt ? toLocalYMD(regDt) : '';

          if (localYmd === localTodayYMD) {
            const paid = Number(item.lab_paid || 0);
            if (paid > 0) {
              todaysCollection += paid;
              const mode = classifyMode(item.lab_pay_mode || '');
              if (mode === 'cash') cashToday += paid;
              else if (mode === 'card') cardToday += paid;
              else if (mode === 'online') onlineToday += paid;
            }
          }

          // include due-payments that were paid today (lab_due_pay_date)
          if (item.lab_due_pay_date) {
            const dueDt = parseServerDate(item.lab_due_pay_date);
            const dueYmd = dueDt ? toLocalYMD(dueDt) : '';
            if (dueYmd === localTodayYMD) {
              const duePaid = Number(item.lab_due_pay_amount || 0);
              if (duePaid > 0) {
                todaysCollection += duePaid;
                const mode = classifyMode(item.lab_due_pay_mode || '');
                if (mode === 'cash') cashToday += duePaid;
                else if (mode === 'card') cardToday += duePaid;
                else if (mode === 'online') onlineToday += duePaid;
              }
            }
          }
        });

        setSummary({
          totalReports,
          totalAmount,
          todaysCollection,
          collectionBy: { cash: cashToday, online: onlineToday, card: cardToday }
        });

        // unique tests
        const uniqueTests = [
          ...new Set(records.flatMap(r => (r.tests || []).map(t => (t.lab_item_test_name || t.test_name || '').trim())).filter(Boolean))
        ];
        setAllTests(uniqueTests.map(n => ({ test_name: n })));

        // BUILD payments list using strict Date comparison (THIS IS THE FIX)
       // build a map of user display names from earlier uMap or userMap
// uMap was earlier created, but keep a safe fallback: use r.last_used / fname
const userDisplayMap = {};
records.forEach(r => {
  const uid = r.last_used_id ?? r.lab_reg_user ?? r.user_id ?? null;
  if (uid) userDisplayMap[String(uid)] = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || (`User #${uid}`);
});

// build payments with resolved user name
const payments = records
  .filter(r => Number(r.lab_due_pay_amount || 0) > 0 && r.lab_due_pay_date)
  .map(r => {
    // lab_due_pay_user may be an id or plain name; attempt to resolve name
    const rawUser = r.lab_due_pay_user ?? r.last_used ?? r.fname ?? '';
    let userName = rawUser;
    if (String(rawUser).match(/^\d+$/) && userDisplayMap[String(rawUser)]) {
      userName = userDisplayMap[String(rawUser)];
    } else if (userDisplayMap[String(r.last_used_id)]) {
      userName = userDisplayMap[String(r.last_used_id)];
    } else if (r.fname) {
      userName = r.fname;
    }
    return {
      lab_reg_id: r.lab_reg_id,
      lab_reg_uhid: r.lab_reg_uhid,
      lab_reg_name: r.lab_reg_name,
      lab_due_pay_mode: r.lab_due_pay_mode || '',
      lab_due_pay_date: r.lab_due_pay_date || '',
      lab_due_pay_amount: Number(r.lab_due_pay_amount || 0),
      lab_due_pay_user: rawUser,
      lab_due_pay_user_name: userName,
      __sourceRow: r
    };
  });


        // convert filter boundaries into Date objects (local timezone)
        // inclusive: from 00:00:00 through to 23:59:59
        const fromDate = formData.from ? new Date(`${formData.from}T00:00:00`) : null;
        const toDate = formData.to ? new Date(`${formData.to}T23:59:59`) : null;

        const paymentsFiltered = payments.filter(p => {
          if (!p.lab_due_pay_date) return false;
          const pd = parseServerDate(p.lab_due_pay_date);
          if (!pd) return false;
          if (fromDate && pd < fromDate) return false;
          if (toDate && pd > toDate) return false;
          return true;
        });

        setPaymentsList(paymentsFiltered);
      } else {
        setMasterList([]);
        setUsersList([]);
        setPaymentsList([]);
        setSummary(prev => ({ ...prev, totalReports: 0, todaysCollection: 0, collectionBy: { cash:0, online:0, card:0 } }));
      }
    } catch (err) {
      console.error("initData error:", err);
      toast.error("Failed to fetch report data.");
    }
  };

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        // doctors
        try {
          const fd2 = new FormData();
          fd2.append('type', "doctor");
          fd2.append('page_no', "none");
          const docResponse = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2);
          if (docResponse.data && docResponse.data.status && Array.isArray(docResponse.data.records) && docResponse.data.records.length > 0) {
            setFormData(prev => ({ ...prev, docs: docResponse.data.records }));
          }
        } catch (e) { console.warn("fetch doctors failed", e); }
        // departments
        try {
          const fd3 = new FormData();
          fd3.append('cat_type', "department");
          fd3.append('page_no', "none");
          const deptResponse = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd3);
          if (deptResponse.data && deptResponse.data.status && Array.isArray(deptResponse.data.records)) {
            setFormData(prev => ({ ...prev, departs: deptResponse.data.records }));
          }
        } catch (e) { console.warn("fetch departments failed", e); }
      } finally {
        await initData();
      }
    };
    fetchMeta();
    // eslint-disable-next-line
  }, []);

  // debounce re-fetch on filter changes
  useEffect(() => {
    const t = setTimeout(() => initData(), 180);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [formData.from, formData.to, formData.lab_reg_referral_user_id, formData.selectedDepartment, formData.selectedTest, formData.search_key, formData.selectedUserId]);

  const filteredList = useMemo(() => {
    let filteredData = [...masterList];

    if (formData.selectedDepartment && formData.selectedDepartment.trim() !== '') {
      const sel = formData.selectedDepartment;
      filteredData = filteredData.filter(item => {
        const params = item.params || [];
        const matchesById = params.some(p => String(p.test_cat) === String(sel));
        const matchesByName = params.some(p => {
          const dept = formData.departs.find(d => String(d.cat_id) === String(p.test_cat));
          return dept && dept.cat_name && dept.cat_name.toLowerCase() === sel.toLowerCase();
        });
        return matchesById || matchesByName;
      });
    }

    if (formData.selectedTest && formData.selectedTest.trim() !== '') {
      const s = formData.selectedTest.toLowerCase();
      filteredData = filteredData.filter(item => {
        const tests = item.tests || [];
        return tests.some(t => (t.lab_item_test_name || t.test_name || '').toLowerCase().includes(s));
      });
    }

    if (formData.selectedUserId && String(formData.selectedUserId).trim() !== '') {
      filteredData = filteredData.filter(item => {
        const uid = item.last_used_id ?? item.lab_reg_user ?? item.user_id ?? null;
        return String(uid) === String(formData.selectedUserId);
      });
    }

    return groupByUHID(filteredData);
  }, [masterList, formData.selectedDepartment, formData.selectedTest, formData.departs, formData.selectedUserId]);

  const finalList = useMemo(() => {
    if (!formData.search_key || formData.search_key.trim() === "") return filteredList;
    const sk = formData.search_key.toLowerCase();
    return filteredList.filter(item =>
      (`${item.lab_reg_uhid || ''}`).toLowerCase().includes(sk) ||
      (`${item.lab_reg_name || ''}`).toLowerCase().includes(sk) ||
      (`${item.lab_reg_mobile || ''}`).toLowerCase().includes(sk)
    );
  }, [filteredList, formData.search_key]);

  // totals: include paymentsList amounts to paid & cash/card/online totals
 // totals: include paymentsList (later payments) and compute final/paid/due correctly
 useEffect(() => {
  // helpers
  const num = v => {
    const n = Number(v ?? 0);
    return Number.isFinite(n) ? n : 0;
  };

  // If nothing, reset
  if ((!finalList || finalList.length === 0) && (!paymentsList || paymentsList.length === 0)) {
    setTotals({
      totalCharges: "0.00",
      finalAmount: "0.00",
      newPaid: "0.00",
      laterPaid: "0.00",
      totalPaid: "0.00",
      discountAmount: "0.00",
      totalDue: "0.00",
      totalRows: 0,
      cashTotal: "0.00",
      cardTotal: "0.00",
      onlineTotal: "0.00"
    });
    return;
  }

  // Build map of later payments by lab_reg_id (paymentsList entries should include lab_reg_id)
  const laterPaidByReg = {};
  let laterPaidTotal = 0;
  let laterCash = 0, laterCard = 0, laterOnline = 0;

  (paymentsList || []).forEach(p => {
    const regId = String(p.lab_reg_id ?? p.__sourceRow?.lab_reg_id ?? 'unknown');
    const amt = num(p.lab_due_pay_amount ?? 0);
    laterPaidTotal += amt;
    laterPaidByReg[regId] = (laterPaidByReg[regId] || 0) + amt;

    const mode = String(p.lab_due_pay_mode || p.__sourceRow?.lab_due_pay_mode || '').toLowerCase();
    if (mode.includes('cash')) laterCash += amt;
    else if (mode.includes('card') || mode.includes('debit') || mode.includes('credit') || mode.includes('swipe')) laterCard += amt;
    else if (mode.includes('upi') || mode.includes('online') || mode.includes('gateway') || mode.includes('net')) laterOnline += amt;
  });

  // Accumulators for grouped rows
  let totalCharges = 0;    // from __firstRow.lab_total if present
  let finalAmount = 0;     // sum of group's final (total_final_amt)
  let groupPaidTotal = 0;  // sum of group's recorded paid amounts
  let discountAmount = 0;
  let cashTotal = 0, cardTotal = 0, onlineTotal = 0;

  (finalList || []).forEach(g => {
    const first = g.__firstRow || {};
    const regId = String(g.lab_reg_id ?? first.lab_reg_id ?? g.lab_reg_uhid ?? '');

    // canonical fields on grouped item
    const groupFinal = num(g.total_final_amt ?? g.lab_final_amt ?? g.total_final ?? (first.lab_final_amt ?? 0));
    const groupPaid = num(g.total_paid ?? g.lab_paid ?? (first.lab_paid ?? 0));
    const groupDue = num(g.total_due ?? g.lab_due ?? Math.max(0, groupFinal - groupPaid));

    // charges: prefer explicit lab_total on the original row
    const rowLabTotal = num(first.lab_total ?? first.lab_total_amt ?? 0);

    totalCharges += rowLabTotal;
    finalAmount += groupFinal;
    groupPaidTotal += groupPaid;

    // discount extraction (try several fields)
    const extractDiscount = (r) => {
      if (!r) return 0;
      if (r.lab_discount !== undefined && r.lab_discount !== null && r.lab_discount !== '') return num(r.lab_discount);
      if (r.lab_dis_amt !== undefined && r.lab_dis_amt !== null && r.lab_dis_amt !== '') return num(r.lab_dis_amt);
      if (r.lab_fix_deposit !== undefined && r.lab_fix_deposit !== null && r.lab_fix_deposit !== '') return num(r.lab_fix_deposit);
      if (r.lab_dis_per !== undefined && r.lab_dis_per !== null && r.lab_dis_per !== '') {
        const base = num(r.lab_total ?? groupFinal);
        return (base * num(r.lab_dis_per)) / 100;
      }
      return 0;
    };
    discountAmount += extractDiscount(g) || extractDiscount(first);

    // payment breakdown recorded on grouped row
    cashTotal += num(g.cash_amount ?? 0);
    cardTotal += num(g.card_amount ?? 0);
    onlineTotal += num(g.online_amount ?? 0);

    // We'll compute per-reg due below (outside this loop) using laterPaidByReg mapping
    // but we still keep groupDue available if needed
  });

  // Now compute totalDue by walking grouped rows and using laterPaidByReg to include later payments per registration
  let computedTotalDue = 0;
  (finalList || []).forEach(g => {
    const first = g.__firstRow || {};
    const regId = String(g.lab_reg_id ?? first.lab_reg_id ?? '');
    const groupFinal = num(g.total_final_amt ?? g.lab_final_amt ?? g.total_final ?? (first.lab_final_amt ?? 0));
    const groupPaid = num(g.total_paid ?? g.lab_paid ?? (first.lab_paid ?? 0));
    const laterForThis = num(laterPaidByReg[regId] || 0);

    // final paid for computation is grouped paid + later payments for the same reg (if those later payments are not already included)
    // This formula is safe even if later payments are already included in groupPaid (laterForThis will be zero or small)
    const effectivePaid = groupPaid + laterForThis;

    let dueForReg = groupFinal - effectivePaid;
    if (!Number.isFinite(dueForReg) || dueForReg < 0) dueForReg = 0;
    computedTotalDue += dueForReg;
  });

  // Merge payment breakdown with later payments breakdown
  cashTotal += laterCash;
  cardTotal += laterCard;
  onlineTotal += laterOnline;

  const totalPaid = groupPaidTotal + laterPaidTotal;

  setTotals({
    totalCharges: totalCharges.toFixed(2),
    finalAmount: finalAmount.toFixed(2),
    newPaid: groupPaidTotal.toFixed(2),
    laterPaid: laterPaidTotal.toFixed(2),
    totalPaid: totalPaid.toFixed(2),
    discountAmount: discountAmount.toFixed(2),
    totalDue: computedTotalDue.toFixed(2),
    totalRows: (finalList || []).length,
    cashTotal: cashTotal.toFixed(2),
    cardTotal: cardTotal.toFixed(2),
    onlineTotal: onlineTotal.toFixed(2)
  });

}, [finalList, paymentsList]);




  const columns = useMemo(() => [
    { name: '#', selector: (row, i) => i + 1, width: '60px' },
    { name: 'UHID', selector: row => row.lab_reg_uhid || '', sortable: true ,width: '160px'},
    {
      name: 'Patient',
      selector: row => `${row.lab_reg_name_title || ''} ${row.lab_reg_name || ''}`,
      sortable: true,
      cell: row => (<div>{row.lab_reg_name_title} {row.lab_reg_name}<br/><small>{row.lab_reg_mobile}</small></div>),
      wrap: true,
      width: '200px'
    },
    { name: 'Referral/Doctor', selector: row => (row.lab_reg_referral || row.fname || row.last_used || ''), width: '220px' },
    { name: 'Total', selector: row => Number(row.total_final_amt || 0).toFixed(2), sortable: true, right: true },
    { name: 'Paid', selector: row => Number(row.total_paid || row.lab_paid || 0).toFixed(2), sortable: true, right: true },
    { name: 'Due', selector: row => Number(row.total_due || row.lab_due || 0).toFixed(2), sortable: true, right: true },

    { name: 'Cash', selector: row => Number(row.cash_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },
    { name: 'Card', selector: row => Number(row.card_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },
    { name: 'Online', selector: row => Number(row.online_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },

    { name: 'Payment Type', selector: row => mapPayMode(row.__firstRow?.lab_pay_mode || row.lab_pay_mode || ''), width: '140px' },

    {
      name: 'User',
      selector: row => (row.last_used || row.fname || row.lab_reg_user || '').toString(),
      width: '160px',
      cell: row => {
        const uid = row.last_used_id ?? row.lab_reg_user ?? row.__firstRow?.user_id ?? '';
        const uname = (row.last_used && row.last_used.trim()) || (row.fname && row.fname.trim()) || (row.__firstRow && (row.__firstRow.fname || row.__firstRow.username)) || `User #${uid}`;
        return <div>{uname}<br/></div>;
      }
    },

    {
      name: 'Date',
      selector: row => {
        const dt = parseServerDate(row.lab_reg_datetime || row.__firstRow?.lab_reg_datetime || '');
        return dt ? dt.getTime() : 0;
      },
      sortable: true,
      cell: row => {
        const dt = parseServerDate(row.lab_reg_datetime || row.__firstRow?.lab_reg_datetime || '');
        return dt ? formatDateTime12h(dt) : '';
      },
      width: '230px'
    }
  ], []);

  const paymentColumns = useMemo(() => [
    { name: '#', selector: (row, i) => i + 1, width: '60px' },
    { name: 'UHID', selector: row => row.lab_reg_uhid || '', sortable: true },
    { name: 'Name', selector: row => row.lab_reg_name || '' },
    { name: 'Payment Mode', selector: row => mapPayMode(row.lab_due_pay_mode), width: '120px' },
    {
      name: 'Date',
      selector: row => {
        const dt = parseServerDate(row.lab_due_pay_date || '');
        return dt ? dt.getTime() : 0;
      },
      sortable: true,
      cell: row => {
        const dt = parseServerDate(row.lab_due_pay_date || '');
        return dt ? formatDateTime12h(dt) : '';
      },
      width: '170px'
    },
    { name: 'Amount', selector: row => Number(row.lab_due_pay_amount || 0).toFixed(2), right: true },
    {
      name: 'User',
      selector: row => row.lab_due_pay_user_name || row.lab_due_pay_user || '',
      width: '180px',
      cell: row => (
        <div>
          {row.lab_due_pay_user_name || row.lab_due_pay_user || ''}
        </div>
      )
    }
    
  ], []);

  const handleClear = () => {
    setFormData(prev => ({
      ...prev,
      search_key: "",
      from: localToday,
      to: localToday,
      lab_reg_referral_user_id: "",
      lab_reg_referral: "",
      selectedDepartment: "",
      selectedTest: "",
      selectedUserId: ""
    }));
    setTimeout(() => initData(), 60);
  };

  // simple PDF export via iframe print (same as earlier)
  function generatePrintHtml(list, payments, totalsForFooter) {
    const style = `
      <style>
        body{font-family: Arial, Helvetica, sans-serif; padding: 20px; color: #222;}
        table{border-collapse: collapse; width:100%; margin-top:10px;}
        th, td{border:1px solid #ccc; padding:6px 8px; text-align:left; font-size:12px;}
        th{background:#f2f2f2;}
        tfoot td{font-weight:600;}
        .footer-summary{margin-top:12px; font-size:13px;}
      </style>
    `;
    const rowsHtml = list.map((r, i) => {
      const userDisplay = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || '';
      return `<tr>
        <td>${i+1}</td>
        <td>${r.lab_reg_uhid || ''}</td>
        <td>${r.lab_reg_name_title || ''} ${r.lab_reg_name || ''}</td>
        <td>${userDisplay}</td>
      </tr>`;
    }).join('');
    const paymentsHtml = payments.map((p, i) => `<tr><td>${i+1}</td><td>${p.lab_reg_uhid || ''}</td><td>${p.lab_reg_name || ''}</td><td>${mapPayMode(p.lab_due_pay_mode)}</td><td>${p.lab_due_pay_date || ''}</td><td style="text-align:right">${Number(p.lab_due_pay_amount || 0).toFixed(2)}</td></tr>`).join('');

    const footerHtml = `
      <div class="footer-summary">
        <div><strong>Total Amount:</strong> ${totalsForFooter.totalAmount}</div>
        <div><strong>Paid Amount:</strong> ${totalsForFooter.paidAmount} &nbsp;|&nbsp;
             <strong>Cash (paid):</strong> ${totalsForFooter.cashTotal} &nbsp;|&nbsp;
             <strong>Card (paid):</strong> ${totalsForFooter.cardTotal} &nbsp;|&nbsp;
             <strong>Online (paid):</strong> ${totalsForFooter.onlineTotal} &nbsp;|&nbsp;
             <strong>Due Amount:</strong> ${totalsForFooter.dueAmount}
        </div>
      </div>
    `;

    return `
      <!doctype html>
      <html>
        <head><meta charset="utf-8" /><title>Lab Reports Print</title>${style}</head>
        <body>
          <h2>Lab Reports</h2>
          <div>Generated on: ${new Date().toLocaleString()}</div>

          <h3 style="margin-top:14px;">Registrations</h3>
          <table>
            <thead><tr><th>#</th><th>UHID</th><th>Name</th><th>User</th></tr></thead>
            <tbody>${rowsHtml}</tbody>
          </table>

          <h3 style="margin-top:14px;">Payments on Reports (Due Payments)</h3>
          <table>
            <thead><tr><th>#</th><th>UHID</th><th>Name</th><th>Mode</th><th>Date</th><th>Amount</th></tr></thead>
            <tbody>${paymentsHtml}</tbody>
          </table>

          ${footerHtml}
        </body>
      </html>
    `;
  }

  // place near other helper functions
const exportPdf = () => {
  try {
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const leftMargin = 36;
    let cursorY = 40;

    // Title
    doc.setFontSize(16);
    doc.text('Lab Reports', leftMargin, cursorY);
    cursorY += 18;
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, leftMargin, cursorY);
    cursorY += 18;

    // Registrations table
    const regs = finalList || [];
    const regHead = ['#', 'UHID', 'Patient', 'User', 'Total', 'Paid', 'Due', 'Date'];
    const regBody = regs.map((r, i) => {
      const userDisplay = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || '';
      const dt = parseServerDate(r.lab_reg_datetime || r.__firstRow?.lab_reg_datetime || '');
      const dateStr = dt ? formatDateTime12h(dt) : '';
      return [
        i + 1,
        r.lab_reg_uhid || '',
        `${r.lab_reg_name_title || ''} ${r.lab_reg_name || ''}`.trim(),
        userDisplay,
        Number(r.total_final_amt || 0).toFixed(2),
        Number(r.total_paid || r.lab_paid || 0).toFixed(2),
        Number(r.total_due || r.lab_due || 0).toFixed(2),
        dateStr
      ];
    });

    if (regBody.length === 0) {
      regBody.push(['', '', 'No records', '', '', '', '', '']);
    }

    autoTable(doc, {
      startY: cursorY,
      head: [regHead],
      body: regBody,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [0, 0, 139] },
      margin: { left: leftMargin, right: leftMargin },
      theme: 'grid',
    });

    cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 18 : cursorY + 200;

    // Payments table heading
    doc.setFontSize(13);
    doc.text('Payments on Reports (Due Payments)', leftMargin, cursorY);
    cursorY += 12;

    // Payments table
    const pays = paymentsList || [];
    const payHead = ['#', 'UHID', 'Name', 'Mode', 'Date', 'Amount', 'User'];
    const payBody = pays.map((p, i) => {
      const dt = parseServerDate(p.lab_due_pay_date || '');
      return [
        i + 1,
        p.lab_reg_uhid || '',
        p.lab_reg_name || '',
        mapPayMode(p.lab_due_pay_mode),
        dt ? formatDateTime12h(dt) : '',
        Number(p.lab_due_pay_amount || 0).toFixed(2),
        p.lab_due_pay_user_name || p.lab_due_pay_user || ''
      ];
    });

    if (payBody.length === 0) {
      payBody.push(['', '', 'No payments', '', '', '', '']);
    }

    autoTable(doc, {
      startY: cursorY,
      head: [payHead],
      body: payBody,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [0, 0, 139] },
      margin: { left: leftMargin, right: leftMargin },
      theme: 'grid',
    });

    cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 20 : cursorY + 200;

    // Footer summary totals (use your totals state)
    const footerLines = [
      `Total (Charges): ${totals.totalCharges}`,
      `Final Amount (Payable): ${totals.finalAmount}`,
      `New Paid: ${totals.newPaid}`,
      `Later Paid: ${totals.laterPaid}`,
      `Total Paid (All): ${totals.totalPaid}`,
      `Discount: ${totals.discountAmount}`,
      `Total Due: ${totals.totalDue}`,
      `Cash (paid): ${totals.cashTotal}`,
      `Card (paid): ${totals.cardTotal}`,
      `Online (paid): ${totals.onlineTotal}`
    ];

    doc.setFontSize(10);
    let fy = cursorY;
    footerLines.forEach(line => {
      if (fy + 12 > doc.internal.pageSize.getHeight() - 40) {
        doc.addPage();
        fy = 40;
      }
      doc.text(line, leftMargin, fy);
      fy += 14;
    });

    // Save file
    doc.save(`lab-reports-${(new Date()).toISOString().slice(0,10)}.pdf`);
  } catch (err) {
    console.error("exportPdf error:", err);
    toast.error("Failed to export PDF - see console.");
  }
};

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',      // larger header text
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px', // row font size
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',      // larger body text
        lineHeight: '55px'
      }
    },
  };
  // UI
  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Two summary cards */}
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="card p-3">
              <p className="mb-1 text-muted"><div
            className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: 50, height: 50 }}
          >
            <i className="bi bi-file-earmark-bar-graph-fill" style={{ fontSize: 26, color: "#198754" }}></i>
          </div>Total Reports</p>
              <h4 className="mb-0" style={{ color: "#14532d" }}>{summary.totalReports}</h4>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card p-3">
              <p className="mb-1 text-muted"><div
            className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: 50, height: 50 }}
          >
            <i className="bi bi-currency-rupee" style={{ fontSize: 26, color: "#198754" }} />
          </div>Total Amount</p>
              <h4 className="mb-0" style={{ color: "#14532d" }}>{summary.totalAmount}</h4>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-3">
                <label>Search</label>
                <input className="form-control" name="search_key" value={formData.search_key} onChange={handleChange} placeholder="UHID / Name / Mobile"/>
              </div>
              <div className="col-md-2">
                <label>From</label>
                <input className="form-control" type="date" name="from" value={formData.from} onChange={handleChange}/>
              </div>
              <div className="col-md-2">
                <label>To</label>
                <input className="form-control" type="date" name="to" value={formData.to} onChange={handleChange}/>
              </div>
              <div className="col-md-3">
                <label>Doctor</label>
                <select className="form-control" value={formData.lab_reg_referral_user_id || "all"} onChange={(e) => {
                  const val = e.target.value === "all" ? "" : e.target.value;
                  const doc = (formData.docs || []).find(d => String(d.user_id) === String(val)) || null;
                  setFormData(prev => ({ ...prev, lab_reg_referral_user_id: val, lab_reg_referral: doc ? doc.fname : '' }));
                }}>
                  <option value="all">All Doctors</option>
                  {(formData.docs || []).map(doc => (
                    <option key={doc.user_id || JSON.stringify(doc)} value={doc.user_id || doc.user_id || doc.user_id}>
                      {doc.fname || doc.name || doc.user_id || doc}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-success me-2" onClick={() => initData()}>Search</button>
                <button className="btn btn-secondary" onClick={handleClear}>Clear</button>
              </div>
            </div>

            {/* Dept / Test / User filters */}
            <div className="row g-2 mt-3">
              <div className="col-md-4">
                <label>Department (search)</label>
                <input list="deptList" className="form-control" value={formData.selectedDepartment} onChange={(e) => setFormData(prev => ({ ...prev, selectedDepartment: e.target.value }))} placeholder="Type to search department..."/>
                <datalist id="deptList">{(formData.departs || []).map((d, i) => <option key={i} value={d.cat_name || d.cat_id || ''}>{d.cat_name}</option>)}</datalist>
              </div>
              <div className="col-md-4">
                <label>Test (search)</label>
                <input list="testList" className="form-control" value={formData.selectedTest} onChange={(e) => setFormData(prev => ({ ...prev, selectedTest: e.target.value }))} placeholder="Type to search test..."/>
                <datalist id="testList">{allTests.map((t, i) => <option key={i} value={t.test_name}>{t.test_name}</option>)}</datalist>
              </div>
              <div className="col-md-4">
                <label>User</label>
                <select className="form-control" value={formData.selectedUserId || "all"} onChange={(e) => {
                  const val = e.target.value === "all" ? "" : e.target.value;
                  setFormData(prev => ({ ...prev, selectedUserId: val }));
                }}>
                  <option value="all">All Users</option>
                  {usersList.map(u => <option key={u.user_id} value={u.user_id}>{u.name}</option>)}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Table + PDF export */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <div />
              <div>
              <button className="btn btn-warning" onClick={exportPdf}>Export PDF</button>

              </div>
            </div>

            <DataTable
              columns={columns}
              data={finalList}
              customStyles={customStyles}
              pagination
              highlightOnHover
              dense
              persistTableHead
              responsive
            />

            <h5 className="mt-4">Payments on Reports (Due Payments)</h5>
            <DataTable
              columns={paymentColumns}
              data={paymentsList}
              customStyles={customStyles}
              pagination
              highlightOnHover
              dense
              persistTableHead
              responsive
            />

            <div className="d-flex justify-content-end mt-3">
            <div className="text-muted" style={{ fontSize: '0.95rem' }}>
  <strong>Total (Charges):</strong> {totals.totalCharges} &nbsp;|&nbsp;
  <strong>Final Amount (Payable):</strong> {totals.finalAmount} &nbsp;|&nbsp;
  <strong>New Paid:</strong> {totals.newPaid} &nbsp;|&nbsp;
  <strong>Later Paid:</strong> {totals.laterPaid} &nbsp;|&nbsp;
  <strong>Total Paid (All):</strong> {totals.totalPaid} &nbsp;|&nbsp;
  <strong>Discount:</strong> {totals.discountAmount} &nbsp;|&nbsp;
  <strong>Total Due:</strong> {totals.totalDue} &nbsp;|&nbsp;
  <strong>Cash (paid):</strong> {totals.cashTotal} &nbsp;|&nbsp;
  <strong>Card (paid):</strong> {totals.cardTotal} &nbsp;|&nbsp;
  <strong>Online (paid):</strong> {totals.onlineTotal}
</div>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default LabReports;
